
import { getFinalPrice } from '~~/helpers/product/getPriceInfo';

export default function useComplementaryProductsTotalPrice() {

  const {
    complementaryBaseProduct,
    complementaryProducts,
    selectedProducts,
  } = useComplementaryProductsStore();

  const selectedProductsPrice = computed<number>(() => {

    if (!complementaryProducts.value || !selectedProducts.value?.length) {

      return 0;
    
    }

    return selectedProducts.value.reduce((total, sku) => {

      const product = complementaryProducts.value.find(p => p.sku === sku);

      if (product) {

        return total + (getFinalPrice(product) ?? 0);

      }

      return total;
    
    }, 0);
  
  });

  const totalPrice = computed<number | null>(() => {

    if (!complementaryBaseProduct.value) {

      return null;
    
    }

    const baseProductFinalPrice = getFinalPrice(complementaryBaseProduct.value);

    if (baseProductFinalPrice === null) {

      return null;

    }

    return baseProductFinalPrice + selectedProductsPrice.value;
  
  });

  return {
    totalPrice,
    selectedProductsPrice,
  };

}
